module.exports = __webpack_public_path__ + "static/media/megagon_logo_transparent.245fdacd.svg";